var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.673965 11.3684C0.673449 13.2168 1.1602 15.0216 2.08575 16.6125L0.585449 22.0478L6.19132 20.5893C7.74184 21.4269 9.47907 21.8657 11.2444 21.8658H11.2491C17.0769 21.8658 21.8209 17.1603 21.8234 11.3766C21.8246 8.57401 20.7256 5.93862 18.7289 3.95589C16.7326 1.97333 14.0776 0.880918 11.2487 0.879639C5.42012 0.879639 0.676457 5.58491 0.674051 11.3684",
    fill: "url(#paint0_linear_350_35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.296543 11.3649C0.295941 13.2799 0.800137 15.1493 1.75868 16.7971L0.20459 22.4273L6.01147 20.9165C7.61146 21.7821 9.41288 22.2385 11.2459 22.2392H11.2507C17.2876 22.2392 22.202 17.3644 22.2046 11.3736C22.2056 8.47031 21.0671 5.74018 18.9991 3.68642C16.9309 1.63291 14.1809 0.501194 11.2507 0.5C5.21268 0.5 0.298949 5.37411 0.296543 11.3649ZM3.75475 16.5133L3.53793 16.1718C2.62648 14.7337 2.1454 13.072 2.14609 11.3656C2.14798 6.38619 6.23207 2.33504 11.2541 2.33504C13.6861 2.33606 15.9717 3.27678 17.6908 4.98357C19.4098 6.69053 20.3557 8.9596 20.3551 11.3729C20.3529 16.3524 16.2687 20.404 11.2507 20.404H11.247C9.61311 20.4032 8.01064 19.9678 6.61312 19.145L6.28054 18.9493L2.83462 19.8458L3.75475 16.5133Z",
    fill: "url(#paint1_linear_350_35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51277 6.82274C8.30773 6.37054 8.09194 6.36142 7.89695 6.35349C7.73727 6.34666 7.55474 6.34718 7.37238 6.34718C7.18985 6.34718 6.89328 6.41531 6.6426 6.6869C6.39166 6.95874 5.68457 7.61567 5.68457 8.95179C5.68457 10.2879 6.66538 11.5793 6.8021 11.7606C6.939 11.9417 8.69556 14.7713 11.4775 15.8599C13.7896 16.7645 14.2601 16.5846 14.7619 16.5392C15.2638 16.494 16.3813 15.8825 16.6093 15.2483C16.8375 14.6142 16.8375 14.0707 16.769 13.9571C16.7006 13.844 16.5181 13.776 16.2444 13.6403C15.9707 13.5045 14.625 12.8474 14.3741 12.7568C14.1232 12.6662 13.9408 12.621 13.7582 12.8929C13.5757 13.1644 13.0516 13.776 12.8918 13.9571C12.7322 14.1387 12.5725 14.1613 12.2988 14.0254C12.025 13.8892 11.1435 13.6027 10.0977 12.6776C9.28406 11.9578 8.73475 11.0688 8.57508 10.7969C8.41541 10.5254 8.55798 10.3782 8.69522 10.2429C8.8182 10.1212 8.96902 9.92576 9.106 9.76724C9.24247 9.60863 9.28802 9.49548 9.37928 9.31436C9.47063 9.13308 9.42491 8.97447 9.35659 8.83863C9.28802 8.7028 8.75615 7.35969 8.51277 6.82274Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_350_35",
    x1: 1062.49,
    y1: 2117.7,
    x2: 1062.49,
    y2: 0.879639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_350_35",
    x1: 1100.2,
    y1: 2193.23,
    x2: 1100.2,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.20459 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.d158f195011af8b9f88bde9b779640de.svg";
export { ForwardRef as ReactComponent };